



































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
  video_link: string = '';
  features = [
    'Free',
    'No Signup',
    'Simple/Manual Tagging',
    'Autoplay Tags/Tracks',
    'Loop',
    'Customise Layout',
    'Annotate',
    'Keyboard Tagging',
    'Clone/Duplicate',
    'Short Links',
    'Mobile Friendly',
  ];

  examples: any = {
    sport: {
      name: 'video',
      params: {
        type: 'youtube',
        id: 'PNvLxIZO54U',
        pathMatch:
          '@default_tab:tracks/Goals: Real Madrid@tag_lag_time:0:05/Goals: Liverpool@tag_lag_time:0:05/1:00:13-1:00:28@track:1@name:Karim Benzema,1:04:30-1:04:45@track:2@name:Sadio Mané@note:Assisted: Dejan Lovren,1:13:05-1:13:20@track:1@name:Gareth Bale@note:Assisted: Marcelo,1:32:46-1:33:01@track:1@name:Gareth Bale@note:Assisted: Marcelo',
      },
      query: {
        show_empty_tracks: false,
      },
    },
    music: {
      name: 'video',
      params: {
        type: 'youtube',
        id: '18NHV4nJLQc',
        pathMatch:
          "@default_track_name:Tracklist/0:00-4:17@name:Life Without You - Jacoo,4:17-9:00@name:Don't Look Back - CMA,9:00-13:00@name:Beneath The Surface - Alicks,13:00-19:44@name:Landfill (Monrroe. Remix) - Daughter,19:44-24:17@name:Momentary BLiss - Crush & NYD,24:17-28:00@name:Coahuila (JacM Remix) - Balmorhea,28:00-31:50@name:The Last String (feat. Oneira) - Jacoo,31:50-36:32@name:Lmaps - MoonRacer,36:32-40:04@name:Fairweather Friend (feat. Cartography) - Resonata,40:04-43:52@name:Andromeda - Jacoo,43:52-48:52@name:Drifting - Andevour,48:52-52:35@name:All Gone (feat. Melissa Pixel) - Michael St Laurent,52:35-58:20@name:I Live You (Chillstep Mix) - Kevin Ciardo",
      },
    },
    event: {
      name: 'video',
      params: {
        type: 'youtube',
        id: '-rAeqN-Q7x4',
        pathMatch:
          '3:20-13:12@name:Apple Arcade,13:12-19:58@name:Apple TV+,19:58-36:35@name:iPad,36:35-46:56@name:Apple Watch Series 5,46:56-1:07:40@name:iPhone 11,1:07:40-1:42:19@name:iPhone 11 Pro',
      },
    },
  };

  tagVideo() {
    this.$router.push(`/${this.video_link}`);
  }
}
